import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './styles.scss'
import inchatActions from 'redux/inchat/actions'
import Message from '../Message'
import { lang } from 'utils/helpers'
import ScrollableContent from 'components/ScrollableContent'

const MessageThreads = ({ conversationId, operatorId, parentId }) => {
  const dispatch = useDispatch()
  const { inchat } = useSelector(store => store)
  const thread = inchat.threads[conversationId] || { messages: [] }
  const newConversationId = parentId ? `${conversationId}_${parentId}` : conversationId

  useEffect(() => {
    dispatch(inchatActions.getMessagesThreadsByMessage(conversationId, 1, newConversationId))
  }, [inchat.parentId])

  const getMessages = async () => {
    if (thread?.isLoadingMessages) return
    if (!thread?.messages) return
    if (thread?.allMessagesGetting) return
    dispatch(inchatActions.getMessagesThreadsByMessage(conversationId, thread?.from + 1, newConversationId))
  }

  return (
    <ScrollableContent onYReachEnd={getMessages} goToTop className={'inchat-threads'}>
      <div className='inchat-chat-messages'>
        {thread?.messages?.map((message, index) => {
          return (
            <Message
              key={index}
              message={message}
              operatorId={operatorId}
              showCountThreads={false}
              showOptions={false}
            />
          )
        })}
        {thread?.isLoadingMessages ?
          <p className='loading-info'>{`${lang('dashboard_loading-messages')}...`}</p>
          : null}
      </div>
    </ScrollableContent>
  )
}

export default MessageThreads